import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Divider, Box } from '@mui/material';
import { bloodInvestigationOptions, bloodTransfusionOptions, opinionOptions, queriesOptions, intakeOutputOptions } from '../constants/options';

const InvestigationsAndOtherSection = ({ formData, setFormData, handleInputChange }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>
        Investigations & Other Orders
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={bloodInvestigationOptions}
            value={formData.blood_investigations_details || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, blood_investigations_details: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Blood Investigations Details" />
            )}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            fullWidth
            label="Date"
            name="blood_investigation_date"
            type="date"
            value={formData.blood_investigation_date || ''}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            fullWidth
            label="Time"
            name="blood_investigation_time"
            type="time"
            value={formData.blood_investigation_time || ''}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={bloodTransfusionOptions}
            value={formData.blood_transfusion_plan || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, blood_transfusion_plan: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Blood Transfusion Plan" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Physiotherapy"
            name="physiotherapy"
            value={formData.physiotherapy || ''}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={opinionOptions}
            value={formData.opinion_or_review || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, opinion_or_review: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Opinion or Review Required" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={queriesOptions}
            value={formData.queries_to_surgeon || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, queries_to_surgeon: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Queries to Surgeon" />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={intakeOutputOptions}
            value={formData.intake_output || ""}
            onInputChange={(e, newVal) => setFormData(prev => ({ ...prev, intake_output: newVal }))}
            renderInput={(params) => (
              <TextField {...params} label="Intake / Output Monitoring" />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InvestigationsAndOtherSection;
